import { CmsStaticPageList } from '../../../../components/Cms';

export function CmsStaticPages() {
  return <CmsStaticPageList />;
}
